import store from '../reduxStore';
import { actions } from '../model';
import { debounce } from '@ifeng-fe/ui_base';

export default debounce(() => {
    const isThermogram = store.getState().uiState.isThermogram;

    if (!isThermogram) {
        store.dispatch(actions.allChipsUpdate());
    }
}, 100);
